import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/web/lib/styling";

const tagVariants = cva(
  "inline-flex h-fit min-w-0 max-w-full items-center justify-center gap-2 overflow-hidden border border-transparent font-medium uppercase tracking-wider",
  {
    variants: {
      variant: {
        outline: "border-border text-foreground/60",
      },
      size: {
        sm: "px-2 py-1 text-[10px] [&_svg]:size-3",
        md: "px-3 py-2 text-sm [&_svg]:size-4",
        lg: "px-4 py-3 text-base [&_svg]:size-5",
        xl: "px-5 py-4 text-lg [&_svg]:size-6",
      },
    },
    defaultVariants: {
      variant: "outline",
      size: "sm",
    },
  },
);

type TagProps = React.ComponentProps<"div"> &
  VariantProps<typeof tagVariants> & {
    icon?: React.ReactNode;
    textClassName?: string;
  };

export function Tag({
  children,
  className,
  variant,
  size,
  icon,
  textClassName,
  ...props
}: TagProps) {
  return (
    <div className={cn(tagVariants({ variant, size }), className)} {...props}>
      {icon ? (
        <>
          <span className="shrink-0">{icon}</span>
          <span className={cn("min-w-0 truncate", textClassName)}>{children}</span>
        </>
      ) : (
        children
      )}
    </div>
  );
}
